// External library imports
import * as yup from 'yup';
// Internal module imports
import { ERRORS, ipv4RegExp, ipv6RegExp } from '../../utils/validationHelper';

export const OnboardingForm = (isPartner = true, meterHasEthernet = false, hasLoggingMeter = false) => {
    return yup.object().shape({
        companyDetails: yup.object().shape({
            companyName: yup.string().required(ERRORS.required),
            add1: yup.string().required(ERRORS.required),
            add2: yup.string().optional(),
            postcode: yup.number().typeError(ERRORS.number).required(ERRORS.required),
            city: yup.string().required(ERRORS.required),
            vat: yup.string().required(ERRORS.required),
            referenceId: yup.string().optional(),
        }),
        contactDetails: yup.object().shape({
            name: yup.string().required(ERRORS.required),
            primaryEmail: yup.string().email().required(ERRORS.required),
            billingEmail: yup.string().email().required(ERRORS.required),
            contact: yup.object().shape({
                number: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                countryCode: yup.number().typeError(ERRORS.number).required(ERRORS.required),
            }),
        }),
        contractDetails: yup.object().shape({
            paymentTerms: yup.number().typeError(ERRORS.number).required(ERRORS.required),
            fixedMonthlyFee: yup.number().typeError(ERRORS.number).required(ERRORS.required),
            monthlyAdminFee: yup.number().typeError(ERRORS.number).required(ERRORS.required),
            aggrementStandardPaymentTerms: yup.object().shape({
                description: yup.string().optional(),
            }),
            tableData: yup.object().shape({
                a: yup.object().shape({
                    customer: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                    ...(isPartner
                        ? { partner: yup.number().typeError(ERRORS.number).required(ERRORS.required) }
                        : { partner: yup.number().typeError(ERRORS.number).nullable().optional() }),
                    sc: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                }),
                b: yup.object().shape({
                    customer: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                    ...(isPartner
                        ? { partner: yup.number().typeError(ERRORS.number).required(ERRORS.required) }
                        : { partner: yup.number().typeError(ERRORS.number).nullable().optional() }),
                    sc: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                }),
                c: yup.object().shape({
                    customer: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                    ...(isPartner
                        ? { partner: yup.number().typeError(ERRORS.number).required(ERRORS.required) }
                        : { partner: yup.number().typeError(ERRORS.number).nullable().optional() }),
                    sc: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                }),
                d: yup.object().shape({
                    customer: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                    ...(isPartner
                        ? { partner: yup.number().typeError(ERRORS.number).required(ERRORS.required) }
                        : { partner: yup.number().typeError(ERRORS.number).nullable().optional() }),
                    sc: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                }),
                e: yup.object().shape({
                    customer: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                    ...(isPartner
                        ? { partner: yup.number().typeError(ERRORS.number).required(ERRORS.required) }
                        : { partner: yup.number().typeError(ERRORS.number).nullable().optional() }),
                    sc: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                }),
                f: yup.object().shape({
                    customer: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                    ...(isPartner
                        ? { partner: yup.number().typeError(ERRORS.number).required(ERRORS.required) }
                        : { partner: yup.number().typeError(ERRORS.number).nullable().optional() }),
                    sc: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                }),
                g: yup.object().shape({
                    customer: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                    ...(isPartner
                        ? { partner: yup.number().typeError(ERRORS.number).required(ERRORS.required) }
                        : { partner: yup.number().typeError(ERRORS.number).nullable().optional() }),
                    sc: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                }),
            }),
        }),
        projectDetails: yup.object().shape({
            shipmentDetails: yup.object().shape({
                name: yup.string().required(ERRORS.required),
                add1: yup.string().required(ERRORS.required),
                add2: yup.string().optional(),
                postcode: yup.number().required(ERRORS.required),
                city: yup.string().required(ERRORS.required),
                contact: yup.object().shape({
                    number: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                    countryCode: yup.number().typeError(ERRORS.number).required(ERRORS.required),
                }),
            }),
            otherProjectDetails: yup.string().optional(),
            gsrn: yup.string().required(ERRORS.required),
            loggingMeter: yup.object().shape({
                meterIpAddress:
                    hasLoggingMeter && meterHasEthernet
                        ? yup
                              .string()
                              .test('is-ip', ERRORS.ip, (v) => !v || ipv4RegExp.test(v) || ipv6RegExp.test(v))
                              .required(ERRORS.required)
                        : yup.string().optional(),
                notes: yup.string().optional(),
            }),
        }),
    });
};
